var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 25,
    viewBox: "0 0 26 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.56938 6.06375L11.1772 1.38281C11.4132 1.0774 11.6898 0.85 12.0069 0.700624C12.3242 0.551249 12.6558 0.476562 13.0019 0.476562C13.3479 0.476562 13.6789 0.551249 13.9947 0.700624C14.3107 0.85 14.5868 1.0774 14.8228 1.38281L18.4306 6.06375L23.9062 7.90375C24.4062 8.07042 24.7986 8.36115 25.0834 8.77594C25.368 9.19052 25.5103 9.64865 25.5103 10.1503C25.5103 10.3818 25.4771 10.613 25.4106 10.8441C25.3444 11.0749 25.2353 11.2961 25.0834 11.5078L21.5625 16.5288L21.6875 21.8413C21.6944 22.5148 21.4686 23.0843 21.0103 23.5497C20.552 24.0149 20.0092 24.2475 19.3819 24.2475C19.3425 24.2475 19.1353 24.2163 18.7603 24.1538L13 22.5497L7.24406 24.1522C7.13698 24.1949 7.02427 24.2215 6.90594 24.2319C6.78781 24.2423 6.67948 24.2475 6.58094 24.2475C5.95052 24.2475 5.40969 24.0135 4.95844 23.5456C4.50698 23.0777 4.29167 22.5026 4.3125 21.8203L4.4375 16.4922L0.927187 11.4872C0.775312 11.2743 0.666146 11.0517 0.599688 10.8194C0.533229 10.5871 0.5 10.3548 0.5 10.1225C0.5 9.62938 0.640104 9.17896 0.920312 8.77125C1.20031 8.36354 1.59146 8.07438 2.09375 7.90375L7.56938 6.06375Z",
    fill: "#D33444"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarRed);
export default __webpack_public_path__ + "static/media/star_red.361f2a1d8585caeb7c0566ef6fb09cd7.svg";
export { ForwardRef as ReactComponent };